import React, { Component } from 'react';

import CashRegisterListComponent from '../components/CashRegisterListComponent';
import CajaScreen from '../components/CajaScreen';
import CashMovementsPanel from '../components/CashMovementsPanel';
import EmployeeAccountPanel from '../components/EmployeeAccountPanel';
import HeaderComponent from '../components/HeaderComponent';
import NavbarComponent from '../components/NavbarComponent';
import SidebarComponent from '../components/SidebarComponent';
import {validateSession, getCashRegister} from '../utils/functions';

class CajaPage extends Component {

	constructor(){
        const cachedRole = Number(localStorage.getItem('role') || 0);
        const cachedCashRegisterStatus = sessionStorage.getItem('cashRegisterStatus');
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole,
            cashRegisterStatus: cachedCashRegisterStatus == null ? 1 : Number(cachedCashRegisterStatus),
            movements: [],
            session: null,
        }
        this.tableRef = React.createRef();
	}

	async componentDidMount() {
        const [role, status] = await Promise.all([
            validateSession(true),
            this.loadCashRegisterStatus(),
        ]);
        this.setState({ checked: true, role:  role, cashRegisterStatus: status});
        this.loadSession();
    }

    // F3: la pantalla se arma alrededor de la SESIÓN, no de un flag. Necesita saber si hay caja
    // abierta, quién la abrió y qué movimientos lleva.
    refreshAll = async () => {
        await this.loadSession();
        const status = await this.loadCashRegisterStatus();
        this.setState({ cashRegisterStatus: status });
        if (this.tableRef.current && typeof this.tableRef.current.fetchData === 'function') {
            this.tableRef.current.fetchData();
        }
    }

    loadSession = async () => {
        try {
            const config = process.env;
            const res = await fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'cashSession', {
                headers: { 'access-token': localStorage.getItem('token') },
            });
            const data = await res.json();
            if (data && data.error === 0 && data.data && data.data.open) {
                this.setState({ session: data.data.session, movements: data.data.movements || [] });
                return;
            }
            this.setState({ session: null, movements: [] });
        } catch (e) {
            this.setState({ session: null, movements: [] });
        }
    }

    loadMovements = async () => {
        try {
            const config = process.env;
            const res = await fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'cashSession', {
                headers: { 'access-token': localStorage.getItem('token') },
            });
            const data = await res.json();
            if (data && data.error === 0 && data.data && data.data.open) {
                this.setState({ movements: data.data.movements || [] });
                return;
            }
            this.setState({ movements: [] });
        } catch (e) {
            this.setState({ movements: [] });
        }
    }

    loadCashRegisterStatus = async () => {
        let cashRegister = await getCashRegister(true)
        let status = ""
        if (cashRegister != undefined) {
            status = cashRegister.data.status
        }
        return status;
    }


	render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else { 
            
            let isSidebar = this.state.role == 1 || this.state.cashRegisterStatus == 1
            let mainWidth = isSidebar ? 10 : 12
            let offset = isSidebar ? 2 : 0
            return (  
                <div className="container-fluid">
                    <div className="row">
                        {isSidebar ? <SidebarComponent itemSelected={12} role={this.state.role}/> : ""}
                        <main className={`main-content col-lg-${mainWidth} col-md-${mainWidth} col-sm-${mainWidth} p-0 offset-lg-${offset} offset-md-${offset-1}`}>
                            <NavbarComponent role={this.state.role} />
                            <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="General" subtitle="Apertura y cierre de caja"/>
                            {/* Los movimientos van PRIMERO: durante el día es lo que más se usa —
                                el cierre se toca una vez, un retiro varias. */}
                            {this.state.session && (
                                <CashMovementsPanel
                                    movements={this.state.movements}
                                    onChange={this.loadSession}
                                />
                            )}
                            {/* La cuenta del equipo (spec-cuenta-empleados). Se muestra SIEMPRE,
                                con la caja abierta o cerrada: ver quién debe no mueve plata, y es
                                justamente lo que hace que un saldo viejo no pase inadvertido. Lo
                                que exige caja abierta es registrar el pago. */}
                            <EmployeeAccountPanel
                                cajaAbierta={!!this.state.session}
                                responsable={this.state.session ? this.state.session.opened_by_name : ''}
                                onChange={this.refreshAll}
                            />
                            {/* La caja es la pantalla: se muestra en modo apertura o cierre según
                                cómo esté. Era un modal y el contenido no entraba. */}
                            <CajaScreen
                                key={this.state.session ? this.state.session.id : 'cerrada'}
                                session={this.state.session}
                                onChange={this.refreshAll}
                            />
                            {/* El historial es información de control: sólo para el admin. */}
                            {this.state.role == 1 && <CashRegisterListComponent ref={this.tableRef}/>}
                            </div>
                        </main>
                    </div>
                </div>
            );
        }
    }
}

export default CajaPage;
